const urlRegexp = new RegExp(/[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,10}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi);

export const validateUrl = url => {
  urlRegexp.lastIndex = 0;

  return urlRegexp.test(url);
};
